module.exports = __webpack_public_path__ + "img/2.98153d23.png";